import React, {Component} from "react";
import NavBar from "./NavBar";


class ApplicantFormSuccessPage extends Component {
    render(){
        return(
            <div>
                <NavBar />
                <h2>
                   Thank you for your interest in becoming an Agent Afrika partner. To start your application we have sent you a verification email. 
                   Click the link in the message to activate your account.
                </h2> 
            </div>
        )
    }

}

export default ApplicantFormSuccessPage;